export const EWA_MAT_DIALOG_DEFAULT_OPTIONS = {
    width: '796px',
};
